<template>
    <div id="Article" class="ecm-article-container" @click="bgClick($event)">

        <button
            @click="closeBtnClick"
            class="ecm-btn-close-article"
            :style="closeBtnInlineStyle">
            <SvgIcon 
                icon="icon-close"
                size="48"
                title="Close">
            </SvgIcon>
            <span class="sr-only">Close</span>
        </button>

        <div class="ecm-article">
            <div v-if="logo" class="ecm-article-logo" :style="logoStyle"></div>

            <div
                v-if="image"
                :style="backgroundImage"
                class="ecm-article-img">
            </div>

            <div class="ecm-article-body">

                <!-- div class="ecm-article-info">
                    <p class="ecm-article-author">Baiba Blogger</p>
                    <p class="ecm-article-datetime">15.4.2021 16:30</p>
                </div -->

                <h1> {{ title }} </h1>

                <div v-html="text"></div>

                <div class="ecm-article-info">

                    <ItemCategories :categories="categories" :showLabels="true" />

                    <div v-if="latitude && longitude" class="ecm-article-place-location">
                        <h2>{{ $t("location") }}</h2>
                        <p>
                            <a :href="googleMapsUrl" target="_blank">{{ latitude }}, {{ longitude }}</a>
                        </p>
                    </div>

                    <div v-if="length" class="ecm-article-route-length">
                        <h2>{{ $t("routeLength") }}</h2>
                        <p>{{ (length / 1000).toFixed(2) }} km</p>
                        <div v-if="gpx">
                            <a :href="downloadGpxUrl" class="ecm-btn ecm-download-gpx-btn" target="_blank">{{ $t("downloadGPX") }}</a>
                        </div>
                    </div>
                </div>

                <p v-if="url" class="text-center">
                    <a :href="url" class="ecm-btn ecm-visit-web-page-btn" target="_blank">{{ $t("visitWebPage") }}</a>
                </p>

            </div>

            <ArticleMap :latitude="latitude" :longitude="longitude" :waypoints="waypointsParsed" />

            <p v-if="source" class="ecm-article-source">
                {{ $t("source") }}: {{ source.name }} / {{ getModifiedDate(modified, lan) }}
            </p>

            <div v-if="$store.state.config.showShareButtons">
                <h2 class="ecm-share-h">Jaa artikkeli</h2>

                <ul class="ecm-share">
                    <li>
                        <a :href="facebookShareUrl" class="ecm-icon-facebook" target="_blank"><span class="sr-only">Share on Facebook</span></a>
                    </li>
                    <li>
                        <a :href="twitterShareUrl" class="ecm-icon-twitter" target="_blank"><span class="sr-only">Share on Twitter</span></a>
                    </li>
                    <li>
                        <a :href="linkedInShareUrl" class="ecm-icon-linkedin" target="_blank"><span class="sr-only">Share on LinkedIn</span></a>
                    </li>
                </ul>
            </div>

        </div>

    </div>
</template>

<script>
import { store } from '../store/store';
import { eventBus } from "../main.js";
import ArticleMap from './ArticleMap.vue';
import ItemCategories from './ItemCategories.vue';
import SvgIcon from './SvgIcon.vue';

export default {
    name: 'Article',
    components: {
        ArticleMap,
        ItemCategories,
        SvgIcon
    },
    props: {
        id: [Number, String],
        title: {
            type: String,
            default: null
        },
        text: {
            type: String,
            default: null
        },
        image: {
            type: String,
            default: null
        },
        url: {
            type: String,
            default: null
        },
        categories: {
            type: Array,
            default: null
        },
        latitude: {
            type: [String, Number],
            default: null
        },
        longitude: {
            type: [String, Number],
            default: null
        },
        waypoints: {
            type: [Array, String],
            default: null
        },
        gpx: {
            type: [Array, String],
            default: null
        },
        length: {
            type: Number,
            default: null
        },
        logo: {
            type: String,
            default: null
        },
        themeColor: {
            type: String,
            default: null
        },
        source: {
            type: Object,
            default: null
        },
        modified: {
            type: String,
            default: null
        },
        mapKey: String,
        sourceId: String
    },
    computed: {
        lan() {
            return store.state.lan;
        },
        logoStyle() {
            let logoStyle = '';

            if (this.themeColor) {
                logoStyle += 'background-color:' + this.themeColor + ';';
            }

            if (this.logo) {
                logoStyle += 'background-image:url(\'' + this.logo + '\');';
            }

            return logoStyle;
        },
        googleMapsUrl() {
            return 'https://www.google.com/maps/place/' + this.latitude + ',' + this.longitude;
        },
        closeBtnInlineStyle() {
            if (this.closeBtnOffset) {
                return 'top:' + this.closeBtnOffset + 'px';
            }
            return null;
        },
        backgroundImage() {
            return "background-image:url('" + this.image + "')";
        },
        /**
         * @returns {string}
         */
        downloadGpxUrl() {
            return process.env.VUE_APP_LOCATIONS_API_PATH + 'routes/' + this.id + '/gpx';
        },
        waypointsParsed() {
            if (Array.isArray(this.waypoints)) {
                return this.waypoints;
            } else if (typeof this.waypoints === 'string') {
                return JSON.parse(this.waypoints);
            }
            return null;
        },
        shareUrl() {
            let url = 'https://matkailukartta.fi/karttamap-article-share.php?type={place|route}&id={id}&mapKey={mapKey}&redirectUrl={redirectUrl}';
            
            if (this.sourceId) {
                url = url.replace('{id}', this.sourceId + '-' + this.id);
            } else {
                url = url.replace('{id}', this.id);
            }

            if (this.waypoints) {
                url = url.replace('{place|route}', 'route');
            } else {
                url = url.replace('{place|route}', 'place');
            }

            url = url.replace('{mapKey}', this.mapKey);
            url = url.replace('{redirectUrl}', encodeURIComponent(window.location.href));
            
            return url;
        },
        facebookShareUrl() {
            //return 'https://www.facebook.com/sharer.php?u=' + encodeURIComponent(window.location.href);
            return 'https://www.facebook.com/sharer.php?u=' + encodeURIComponent(this.shareUrl);
        },
        twitterShareUrl() {
            //return 'https://twitter.com/share?url=' + encodeURIComponent(window.location.href);
            return 'https://twitter.com/share?url=' + encodeURIComponent(this.shareUrl);
        },
        linkedInShareUrl() {
            //return 'https://www.linkedin.com/cws/share?url=' + encodeURIComponent(window.location.href);
            return 'https://www.linkedin.com/cws/share?url=' + encodeURIComponent(this.shareUrl + '&redirect=false');
        }
    },
    data() {
        return {
            closeBtnOffset: null
        };
    },
    mounted() {
        // Set close btn offset if header element is present
        let header = document.querySelector(store.state.config.headerSelector);
        if (header) {
            this.closeBtnOffset =  header.offsetHeight;
        }
    },
    methods: {
        closeBtnClick() {
            eventBus.$emit('closeArticle');
        },
        bgClick(e) {
            // Close article if the bg overlay is clicked
            if (e.target.classList.contains('ecm-article-container'))
            {
                eventBus.$emit('closeArticle');
            }
        },
        getModifiedDate(modified, lan) {
            if (modified) {
                return this.$formatDate(modified, lan);
            }
            // No modified date, use today
            return this.$formatDate(Date(), lan);
        }
    }
}

</script>

<style scoped>
.ecm-btn-close-article,
.ecm-btn-close-article:hover {
    position: fixed !important;
    top: 0;
    right: 16px !important;
    width: 48px;
    height: 48px;
    background-color: transparent !important;
    border: none !important;
    padding: 0;
    opacity: .75;
    z-index: 9999;
}

.ecm-btn-close-article:hover {
    opacity: 1;
}

.ecm-download-gpx-btn {
    margin: 1rem 0;
}

.ecm-visit-web-page-btn {
    padding: 1rem 2rem !important;
    margin: 1rem 0;
}

.ecm-share-h {
    text-align: center;
    border: none;
    margin: 3rem 0 1rem 0;
}

.ecm-share {
    text-align: center;
    padding: 0;
    margin: 0 0 2rem 0;
    display: flex;
    justify-content: center;
}

.ecm-share li {
    list-style-type: none;
}

.ecm-share a {
    display: block;
    width: 64px;
    height: 64px;
    background-size: 64px 64px;
    margin: 0 .5rem;
}

.ecm-icon-facebook {
    background-image: url('../assets/icons/icon-facebook.svg');
}

.ecm-icon-twitter {
    background-image: url('../assets/icons/icon-twitter.svg');
}

.ecm-icon-linkedin {
    background-image: url('../assets/icons/icon-linkedin.svg');
}

@media (max-width: 1200px) {
    .ecm-btn-close-article,
    .ecm-btn-close-article:hover {
        right: 0 !important;
        background-color: var(--km-theme-color) !important;
        border-top-left-radius: 0 !important;
        border-top-right-radius: 0 !important;
        border-bottom-right-radius: 0 !important;
        opacity: 1;
    }
    .ecm-btn-close-article:hover {
        background-color: var(--km-theme-hover-color) !important;
    }
}

</style>
